import { buildApiUrl } from 'fake-db/apiConfig'
import Mock from '../../mock'
import axios from 'axios.js'


const getAllWriteOffUser = async ()=>{
    const response = await axios.get(buildApiUrl('reference/getAllWriteOff/'));

    const {error, errorInfo, result, message, data } = response.data;
    const AllWriteOffUser = data;

    // console.log('Сервер вернул данные по цветам - ',data);


    return AllWriteOffUser;
};


const setActiveWriteOff = async (id,val)=>{
    const response = await axios.post(buildApiUrl('reference/setWriteOffActive/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllWriteOffUser = data;

    // console.log('Сервер вернул данные по обновлению статуса WriteOff  - ',response);


    return AllWriteOffUser;
};



const setDeletedWriteOff = async (id,val)=>{
    const response = await axios.post(buildApiUrl('reference/setWriteOffDeleted/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllWriteOffUser = data;

    // console.log('Сервер вернул данные по обновлению статуса WriteOff  - ',response);


    return AllWriteOffUser;
};




const setUpdateWriteOff = async (dataWriteOffUpdate)=>{
    const response = await axios.post(buildApiUrl('reference/setWriteOffUpdate/'),{
        dataWriteOffUpdate
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllWriteOffUser = data;

    // console.log('Сервер вернул данные по обновлению статуса WriteOff  - ',response);


    return AllWriteOffUser;
};


const setSaveNewWriteOff = async (dataWriteOffUpdate)=>{
    const response = await axios.post(buildApiUrl('reference/setSaveNewWriteOff/'),{
        dataWriteOffUpdate
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllWriteOffUser = data;

    // console.log('Сервер вернул данные по обновлению статуса WriteOff  - ',response);


    return AllWriteOffUser;
};

Mock.onGet('/api/reference/getAllWriteOff').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    const AllWriteOffUser = await getAllWriteOffUser();

    // if (!AllWriteOffUser) {
    //     return [400, { message: 'Список цветов отсутствует!' }]
    // }


    if (!AllWriteOffUser) {
        return [200, [] ]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllWriteOffUser,
    ]


})


Mock.onPost('/api/reference/setActiveWriteOff').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllWriteOffUser = await setActiveWriteOff(id,val);

    // if (!AllWriteOffUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllWriteOffUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllWriteOffUser,
    ]


})

Mock.onPost('/api/reference/setDeletedWriteOff').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllWriteOffUser = await setDeletedWriteOff(id,val);

    // if (!AllWriteOffUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllWriteOffUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllWriteOffUser,
    ]


})


Mock.onPost('/api/reference/setUpdateWriteOff').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataWriteOffUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const refereWriteOff = await setUpdateWriteOff(dataWriteOffUpdate);

    // console.log('Серовер вернул данные ',AllWriteOffUser);

    // if (!refereWriteOff) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!refereWriteOff) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        refereWriteOff,
    ]


})


Mock.onPost('/api/reference/setSaveNewWriteOff').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataWriteOffUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const refereWriteOff = await setSaveNewWriteOff(dataWriteOffUpdate);

    // console.log('Серовер вернул данные ',AllWriteOffUser);

    // if (!refereWriteOff) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!refereWriteOff) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        refereWriteOff,
    ]
})